import { use, useEffect } from "react";
import { DocumentContext } from "../../contexts/DocumentManager";
import ModalDialogFrame from "../ModalDialogFrame";
import DocumentEditor from "./DocumentEditor";

/**
 * The DocumentEditor rendered as a navigation modal SCREEN (registered in navigations/Navigator.tsx),
 * presented the same way on every platform: an animated centered dialog on desktop web (shared
 * ModalDialogFrame, like CreateMissionStack / the editor navigators) and a native-stack modal on
 * iOS/Android. As a real navigation modal it stacks above other modals — unlike a root-mounted RN
 * Modal, which can't present over an already-presented native modal on iOS.
 *
 * The edit session (document + callbacks) lives in DocumentManager and is read here through context:
 * the callbacks aren't serialisable, so they can't travel as navigation params. The session is cleared
 * when the screen goes away (close button, save, or a swipe/back dismiss), which unmounts this screen.
 */
const DocumentEditorScreen = () => {
    const { editorSession, closeEditor, clearEditorSession } = use(DocumentContext);

    useEffect(() => clearEditorSession, [clearEditorSession]);

    if (!editorSession.document) {
        return null;
    }

    return (
        <ModalDialogFrame>
            <DocumentEditor
                document={editorSession.document}
                mimeType={editorSession.mimeType}
                onSave={editorSession.onSave}
                onRemove={editorSession.onRemove}
                onClose={closeEditor}
            />
        </ModalDialogFrame>
    );
};

export default DocumentEditorScreen;
